"use strict";
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class
 * Class representing MiddlewareControl
 */
var MiddlewareControl = /** @class */ (function () {
    /**
     * @public
     * @constructor
     * Creates an instance of MiddlewareControl
     * @param {MiddlewareOptions[]} middlewareOptions - The array of middlewareOptions
     * @returns The instance of MiddlewareControl
     */
    function MiddlewareControl(middlewareOptions) {
        this.middlewareOptions = new Map();
        for (var _i = 0, middlewareOptions_1 = middlewareOptions; _i < middlewareOptions_1.length; _i++) {
            var option = middlewareOptions_1[_i];
            var name_1 = option.constructor.name;
            this.middlewareOptions.set(name_1, option);
        }
    }
    /**
     * @public
     * To get the middleware option using the class name of the option
     * @param {string} name - The class name of the strongly types option class
     * @returns The middleware option
     */
    MiddlewareControl.prototype.getMiddlewareOptions = function (name) {
        return this.middlewareOptions.get(name);
    };
    return MiddlewareControl;
}());
exports.MiddlewareControl = MiddlewareControl;
//# sourceMappingURL=MiddlewareControl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/microsoft-graph-client/lib/src/middleware/MiddlewareControl.js
// module id = 2lRI
// module chunks = 0